import axios from "../../api/axios";
import IFloor from "../../models/floor";
import IFloorResponse from "../../models/floor/floorResponse";
import Auth from "../auth/AuthService";

class FloorService {
    GetFloors = async (propertyGroupId: number) => {
        const url = "/api/hblogin/floor/GetFloorsByPropertyGroup";
        return (
            await axios.get<IFloor[]>(url, {
                headers: { Authorization: Auth.guid },
                params: { propertyGroupId },
            })
        ).data || [];
    };

    GetFloorsByBuildingId = async (buildingId: number) => {
        const url = "/api/hblogin/floor/GetFloorsByBuilding";
        return (
            await axios.get<IFloor[]>(url, {
                headers: { Authorization: Auth.guid },
                params: { buildingId },
            })
        ).data || [];
    };




    GetFloorsByCompany = async () => {
        const url = "/api/hblogin/Floor/GetFloorsByCompany";
        return (
            await axios.get<IFloorResponse[]>(url, {
                headers: { Authorization: Auth.guid },
            })
        ).data || [];
    };
    GetFloorById = async (floorId: number) => {
        const url = "/api/hblogin/Floor/GetFloor";
        return (
            await axios.get<IFloor>(url, {
                headers: { Authorization: Auth.guid },
                params: { floorId },
            })
        ).data;
    };

    PostFloor = async (floor: FormData) => {
        const URI = "/api/hblogin/Floor/PostFloor";
        return (
            await axios.post(URI, floor, {
                headers: {
                    Authorization: Auth.guid,
                    "Content-Type": "multipart/form-data",
                },
            })
        )
    };

    PutFloor = async (floor: FormData) => {
        const URI = "/api/hblogin/Floor/PutFloor";
        return (
            await axios.put(URI, floor, {
                headers: {
                    Authorization: Auth.guid,
                    "Content-Type": "multipart/form-data",
                },
            })
        )
    };
}

export default new FloorService();
